import React from 'react';
import Warning from 'Common/Components/Warning';
import { Wrapper, ModalWrapper } from 'Common/Components/ConfirmNavigationModal/styled';
import { StyledMessage, Asterisk } from './styled';
import useKeypress from 'Hooks/useEscKey';

const Message = ({ errorMessage }) => (
  <StyledMessage>{ errorMessage } ( <Asterisk /> )</StyledMessage>
);

const CreationWarning = ({ errorTitle, errorMessage, onClose }) => {
  useKeypress('Escape', () => {
    onClose();
  });

  return (
    <Wrapper>
      <ModalWrapper>
        <Warning
          title={ errorTitle }
          children={ <Message errorMessage={ errorMessage } /> }
          onClose={ onClose }
        />
      </ModalWrapper>
    </Wrapper>
  );
};

export default CreationWarning;
